import React from "react";

import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";

const Footer = () => {
  return (
    <div className='bg-white md:p-4 xs:p-1 flex flex-col xs:mt-2 justify-center items-center'>
      <div className=' flex justify-center items-center space-x-8 xs:mt-1'>
        <FacebookIcon className='facebook' />
        <InstagramIcon className='instagram' />
        <TwitterIcon className='twitter' />
      </div>
      <h6 className='text-gray-700 font-light md:mt-3 xs:mt-2'>
        @2021 This is Payda clone
      </h6>
      <div class='flex divide-x divide-color font-light xs:hidden'>
        <div className='px-3'>Privacy Policy</div>
        <div className='px-3'>Terms Of Use</div>
      </div>
    </div>
  );
};

export default Footer;
